/*
 * Pipeline Theme - Custom JS
 * Video Slideshow: FlickityFade (fade: true) + 常時再生方式
 *
 * ■ 設計方針
 * - fade: true でスライドをスタックし opacity で切り替える（テーマ本体と同じ）
 * - 全動画を常時再生し、pause/resume のちらつきを排除する
 * - 初回ページロード時はローディングオーバーレイを表示し、
 *   最初の動画が再生可能になったらフェードアウトさせる
 */

(function () {

  var videoSlideshowInstances = {};

  // --- ローディングオーバーレイ制御 ---
  var overlayDismissed = false;
  function dismissOverlay() {
    if (overlayDismissed) return;
    overlayDismissed = true;
    var overlay = document.getElementById('page-loading-overlay');
    if (!overlay) return;
    overlay.classList.add('is-loaded');
    // アニメーション完了後にDOMから削除
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 800);
  }

  function initVideoSlideshow(container) {
    var wrapper = container.querySelector('[data-slideshow-wrapper]');
    if (!wrapper) return;

    // 既にFlickityが初期化済みの場合はスキップ
    if (wrapper.classList.contains('flickity-enabled')) return;

    var speed = wrapper.getAttribute('data-slideshow-speed');
    var autoplay = wrapper.getAttribute('data-slideshow-autoplay') === 'true';
    var slideCount = parseInt(wrapper.getAttribute('data-slideshow-slides'), 10);

    // FlickityFade を優先的に使用（テーマ本体と同じ方式）
    var FlkConstructor = (typeof themeVendor !== 'undefined' && themeVendor.FlickityFade)
      ? themeVendor.FlickityFade
      : (typeof themeVendor !== 'undefined' && themeVendor.Flickity)
        ? themeVendor.Flickity
        : null;

    if (!FlkConstructor) {
      console.warn('[video-slideshow] Flickity not found');
      startAllVideosIn(wrapper);
      dismissOverlay();
      return;
    }

    var flkty;

    var flickityOptions = {
      autoPlay: autoplay && speed ? parseInt(speed, 10) : false,
      contain: false,
      pageDots: true,
      adaptiveHeight: true,
      accessibility: true,
      wrapAround: slideCount !== 2,
      prevNextButtons: false,
      draggable: true,
      fade: true,
      pauseAutoPlayOnHover: false,
      rightToLeft: window.isRTL || false
    };

    try {
      flkty = new FlkConstructor(wrapper, flickityOptions);
    } catch (e) {
      console.error('[video-slideshow] Flickity init failed:', e);
      startAllVideosIn(wrapper);
      dismissOverlay();
      return;
    }

    // --- 動画再生制御 ---

    function playVideo(v) {
      if (!v) return;
      v.muted = true;
      v.playsInline = true;

      // 既に再生済みなら、単純に play() するだけ
      if (v._hasPlayedOnce) {
        var p = v.play();
        if (p !== undefined) p.catch(function () {});
        return;
      }

      var playPromise = v.play();
      if (playPromise !== undefined) {
        playPromise.then(function () {
          v._hasPlayedOnce = true;
          v.removeAttribute('poster');
          v.style.opacity = '1';

          // 親の background-image を非表示にする
          var frame = v.closest('.image__hero__frame');
          if (frame) {
            frame.style.backgroundImage = 'none';
          }

          // この動画が1枚目のスライドのものなら、動画が確実に「動いている」ことを検知してからオーバーレイを解除する
          var slide = v.closest('[data-slideshow-index]');
          if (slide && slide.getAttribute('data-slideshow-index') === '0') {
            var isDismissed = false;
            var checkPlaying = function() {
              if (v.currentTime > 0.1 && !isDismissed) {
                isDismissed = true;
                dismissOverlay();
                v.removeEventListener('timeupdate', checkPlaying);
              }
            };
            v.addEventListener('timeupdate', checkPlaying);
            // 安全装置：万が一 timeupdate イベントが正常に発火しないブラウザ環境のため、3秒で強制解除
            setTimeout(function() {
              if (!isDismissed) {
                isDismissed = true;
                dismissOverlay();
                v.removeEventListener('timeupdate', checkPlaying);
              }
            }, 3000);
          }
        }).catch(function (err) {
          console.warn('[video-slideshow] play() rejected:', err.message);
          // 低電力モード等で再生がブロックされた場合、5秒のフォールバックを待たずに即座に解除
          var slide = v.closest('[data-slideshow-index]');
          if (slide && slide.getAttribute('data-slideshow-index') === '0') {
            dismissOverlay();
          }
          retryPlayOnVisible(v);
        });
      }
    }

    function playAllVideosIn(slide) {
      if (!slide) return;
      var videos = slide.querySelectorAll('video[data-video-autoplay]');
      for (var i = 0; i < videos.length; i++) {
        playVideo(videos[i]);
      }
    }

    function startAllVideosIn(el) {
      var allSlides = el.querySelectorAll('[data-slideshow-index]');
      for (var i = 0; i < allSlides.length; i++) {
        playAllVideosIn(allSlides[i]);
      }
    }

    function retryPlayOnVisible(v) {
      if (!('IntersectionObserver' in window)) {
        setTimeout(function () { playVideo(v); }, 1000);
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            observer.disconnect();
            playVideo(v);
          }
        });
      }, { threshold: 0.25 });
      observer.observe(v);
    }

    // --- 全動画を常時再生（pause/resume のちらつきを排除）---
    function startAllVideos() {
      startAllVideosIn(wrapper);
    }

    // 初期起動: 全動画の再生を開始
    startAllVideos();
    setTimeout(startAllVideos, 300);

    // Flickity のイベントでは何もしない（全動画が常時再生されるため）
    // ただし、新しいスライドが追加された場合等に備えて startAllVideos を呼ぶ
    flkty.on('change', startAllVideos);

    // 動画のメタデータ読み込み完了時に Flickity のサイズを再計算
    var allVideos = wrapper.querySelectorAll('video[data-video-autoplay]');
    for (var i = 0; i < allVideos.length; i++) {
      (function (v) {
        var doResize = function () {
          if (flkty) flkty.resize();
        };
        if (v.readyState >= 1) {
          doResize();
        } else {
          v.addEventListener('loadedmetadata', doResize, { once: true });
        }
      })(allVideos[i]);
    }

    // カスタム prev/next ボタン
    var prevBtns = wrapper.querySelectorAll('[data-slide-custom-prev]');
    var nextBtns = wrapper.querySelectorAll('[data-slide-custom-next]');
    for (var p = 0; p < prevBtns.length; p++) {
      prevBtns[p].onclick = function () { flkty.previous(true, false); };
    }
    for (var n = 0; n < nextBtns.length; n++) {
      nextBtns[n].onclick = function () { flkty.next(true, false); };
    }

    // スクロール量に応じて autoplay を停止/再開
    function onScroll() {
      if (!autoplay || !speed || !flkty || !flkty.player) return;
      var rect = wrapper.getBoundingClientRect();
      var outOfView = rect.bottom < 0 || rect.top > window.innerHeight;
      if (outOfView) {
        if (flkty.player.state === 'playing') flkty.pausePlayer();
      } else {
        if (flkty.player.state === 'paused') {
          if (typeof flkty.unpausePlayer === 'function') {
            flkty.unpausePlayer();
          } else {
            flkty.playPlayer();
          }
        }
      }
    }
    document.addEventListener('theme:scroll', onScroll);

    // スクロールダウン矢印ボタン
    var scrollBtn = container.querySelector('[data-scroll-down]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', function () {
        window.scrollTo({ top: container.offsetTop + container.offsetHeight, behavior: 'smooth' });
      });
    }

    // インスタンスを保存
    var sectionId = container.getAttribute('data-section-id');
    videoSlideshowInstances[sectionId] = { flkty: flkty, onScroll: onScroll };
    wrapper._flkty = flkty;
  }

  function destroyVideoSlideshow(container) {
    var sectionId = container.getAttribute('data-section-id');
    var instance = videoSlideshowInstances[sectionId];
    if (!instance) return;
    document.removeEventListener('theme:scroll', instance.onScroll);
    if (instance.flkty) instance.flkty.destroy();
    var wrapper = container.querySelector('[data-slideshow-wrapper]');
    if (wrapper) wrapper._flkty = null;
    delete videoSlideshowInstances[sectionId];
  }

  // --- ページ初期化 ---
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var containers = document.querySelectorAll('[data-section-type="video-slideshow"]');
    if (containers.length === 0) {
      dismissOverlay();
      return;
    }

    var hasAnyFirstSlideVideo = false;
    containers.forEach(function(container) {
      var firstSlide = container.querySelector('[data-slideshow-index="0"]');
      if (firstSlide && firstSlide.querySelector('video[data-video-autoplay]')) {
        hasAnyFirstSlideVideo = true;
      }
    });

    if (!hasAnyFirstSlideVideo) {
      // 1枚目のスライドが動画ではない場合（画像など）、即座にオーバーレイを解除
      dismissOverlay();
    }

    // クローン等の作成前に、全自動再生動画から一括でposter属性を削除（フラッシュ防止）
    document.querySelectorAll('video[data-video-autoplay]').forEach(function(v) {
      v.removeAttribute('poster');
    });

    containers.forEach(initVideoSlideshow);

    // 動画の再生が5秒以内に始まらなかった場合のフォールバック
    setTimeout(dismissOverlay, 5000);
  });

  // --- テーマエディタ対応 ---
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target;
    var container = section.querySelector('[data-section-type="video-slideshow"]')
      || (section.dataset && section.dataset.sectionType === 'video-slideshow' ? section : null);
    if (container) initVideoSlideshow(container);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target;
    var container = section.querySelector('[data-section-type="video-slideshow"]')
      || (section.dataset && section.dataset.sectionType === 'video-slideshow' ? section : null);
    if (container) destroyVideoSlideshow(container);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-slideshow-index]');
    if (!slide) return;
    var wrapper = slide.closest('[data-slideshow-wrapper]');
    if (!wrapper || !wrapper._flkty) return;
    var index = parseInt(slide.getAttribute('data-slideshow-index'), 10);
    wrapper._flkty.selectCell(index);
    wrapper._flkty.stopPlayer();
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var wrapper = e.target.closest('[data-slideshow-wrapper]');
    if (!wrapper || !wrapper._flkty) return;
    var autoplay = wrapper.getAttribute('data-slideshow-autoplay') === 'true';
    if (autoplay) wrapper._flkty.playPlayer();
  });

})();